import { Box } from '@mui/material';
import { RegistrationNavBar } from '../registration/components/registrationNavBar';
import { useTranslation } from 'react-i18next';
import { LanguageService } from '../../services/languageService';
import { InvestorDocuments } from '../investor/views/profile/documents';
import { getLoginInfo, getRegistrationInfo } from '../../services/authService';
import { IS_SA } from '../../config/appConfig';
import { UserNafathVerification } from '../../shared/components/userNafathVerification';
import { useState } from 'react';
import { LogoutDialog } from '../../shared/components/logoutDialog';

export const Winddown = () => {
	const languageService = new LanguageService();
	const [showLogoutDialog, setLogoutDialog] = useState(false);
	const { t } = useTranslation();

	const isArabic = () => {
		return languageService.isArabic();
	};


	return (
		<Box>
			<RegistrationNavBar></RegistrationNavBar>
			<Box className="flex justify-center items-center">
				<Box className="xl:w-[1140px] w-full md:my-8 m-4 justify-center items-center flex flex-col md:min-h-[calc(100vh-310px)]">
					<Box className="flex flex-col items-center">
						<h1 className="md:text-5xl font-[600] my-4">
							{t('accountUnderWinddown')}
						</h1>
						{IS_SA && getLoginInfo()?.showNafathPage ?
							<Box>
								<p className='mb-4'>{t('yourAccountIsUnderWindownNafath')}</p>
								<UserNafathVerification showMainSection={false} onSuccess={() => {
									setTimeout(() => {
										setLogoutDialog(true);
									}, 1000);
								}} />
							</Box>
							: <Box className="flex flex-col">
								<Box className="!mb-4">
									<InvestorDocuments
										investorType={
											getRegistrationInfo()?.investorType
										}></InvestorDocuments>
								</Box>
								{!isArabic() ? (
									<p className='text-center'>
										{t('accountUnderWinddownText')}
										<a
											className="underline-link mx-1"
											href="mailto:support@fundingsouq.com">
											support@fundingsouq.com
										</a>
									</p>
								) : (
									<p className='text-center'>
										{t('accountUnderWinddownText')}
										<a
											className="underline-link mx-1"
											href="mailto:support@fundingsouq.com">
											support@fundingsouq.com
										</a>
										{t('accountUnderWinddownText2')}
									</p>
								)}
							</Box>
						}
					</Box>
				</Box>
			</Box>
			{showLogoutDialog ? <LogoutDialog open={showLogoutDialog} text='logOutAndLoginAgainNafath' onClose={(e) => setLogoutDialog(false)} /> : null}
		</Box>
	);
};
